import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="news-articles"
export default class extends Controller {
  static targets = ["newsArticle"]
  static values = {
    id: String,
  }

  connect() {
    const firstNewsArticle = document.getElementById(this.idValue)
    this.applyProperties(firstNewsArticle)
  }

  select() {
    this.unselectPrevious()
    this.applyProperties(this.newsArticleTarget)
  }

  applyProperties(element) {
    element?.classList.replace("hover:bg-stone-50", "bg-purple-100")
    element?.classList.add("font-bold")
  }

  unselectPrevious() {
    const newsArticle = document.getElementsByClassName(
      "bg-purple-100 font-bold",
    )[0]
    newsArticle?.classList.replace("bg-purple-100", "hover:bg-stone-50")
    newsArticle?.classList.remove("font-bold")
  }
}
